import http from "./Http";

const getAll = async () => {
    return http.get("/managed-dns-zones");
};

const get = async (id) => {
    return http.get(`/managed-dns-zones/${id}`);
};

const create = async (body) => {
    return http.post("/managed-dns-zones", body);
};

const update = async (id, body) => {
    return http.put(`/managed-dns-zones/${id}`, body);
};

const remove = async (id) => {
    return http.delete(`/managed-dns-zones/${id}`);
};

const ManagedDnsZonesService = {
    getAll,
    get,
    create,
    update,
    remove,
};

export default ManagedDnsZonesService;
